// extracted by mini-css-extract-plugin
export default {"tooltip":"AssessmentModal_tooltip__LmE+8","tooltip-content":"AssessmentModal_tooltip-content__u0GrM"};